export default "__VITE_ASSET__DWtvCvRU__"